import React, { useState } from "react";
import { Card, Row, Col, Tag, Button, Typography, Flex, Tooltip, notification } from "antd";
import "./styles.scss";
import PencilIcon from "images/svgIcons/pencil";
import { CopyOutlined, InfoCircleOutlined } from "@ant-design/icons";
import usePrimaryColor from "helpers/hooks/usePrimaryColor";
import GoLive from "./GoLive";
import LiveStreamIcon from "images/svgIcons/live-stream";
import { workoutTypes } from "helpers/constants";

const Categories = ({ categories, number }) => {
	return (
		<Flex data-id="blockLiveCategories">
			{categories.slice(0, number).map((category, index) => (
				<Tag key={index}>{category.name}</Tag>
			))}
			{categories.length > number && (
				<Tooltip
					title={categories
						.slice(number)
						.map((category) => category.name)
						.join(", ")}
				>
					<div className="tag more-tag">{`+${categories.length - number}`}</div>
				</Tooltip>
			)}
		</Flex>
	);
};
const LiveWorkoutCard = ({
	image,
	workoutName,
	dateTime,
	categories,
	musicGenre,
	onGoLiveClick,
	streamKey,
	onEditClick,
	refetchStreams,
	workout,
}) => {
	const [isModalVisible, setIsModalVisible] = useState(false);
	const primaryColor = usePrimaryColor();
	const hasKey = streamKey && streamKey.length > 0;
	const openGoLiveModal = () => {
		if (workout.currently_streaming || !hasKey) return;
		setIsModalVisible(true);
		onGoLiveClick?.();
	};
	return (
		<Card className="live-workout-card" data-id="sectionGoLive">
			<Row justify="space-between" gutter={16} align="middle" data-id="sectionGoLiveDetails">
				<Col flex={1}>
					<Flex align="center" style={{ marginBottom: 8 }} gap={8}>
						<img
							src={image}
							alt="workout"
							style={{ width: 96, height: 54, borderRadius: 8 }}
							data-id="imgLiveThumbnail"
						/>
						<div style={{ maxWidth: 280, overflow: "hidden" }}>
							{workout.currently_streaming ? (
								<Typography.Text
									style={{
										color: "#fff",
										backgroundColor: primaryColor,
										fontSize: 10,
										padding: "2px 8px",
										borderRadius: 15,
										display: "inline-flex",
										alignItems: "center",
									}}
									ellipsis
								>
									<LiveStreamIcon />
									<span style={{ marginLeft: 8 }}>Live</span>
								</Typography.Text>
							) : (
								<Typography.Text ellipsis className="date-time" data-id="lblLiveTime">
									<LiveStreamIcon />
									{dateTime}
								</Typography.Text>
							)}
							<br />
							<Typography.Paragraph className="workout-name" ellipsis data-id="lblLiveTitle">
								{workoutName}
							</Typography.Paragraph>
						</div>
					</Flex>
				</Col>
				<Col style={{ display: "flex" }} data-id="sectionLiveTags">
					{musicGenre && <Tag>{musicGenre}</Tag>}
					<Categories categories={categories} number={1} />
				</Col>
				{hasKey && (
					<Col
						style={{ width: window.innerWidth < 768 ? "100%" : "unset" }}
						flex={window.innerWidth < 768 ? 1 : undefined}
					>
						<div className="stream-key">
							<Typography.Text
								style={{ fontSize: 12 }}
								ellipsis={!(window.innerWidth < 768)}
								copyable={{
									text: streamKey,
									icon: <CopyOutlined style={{ cursor: "pointer", color: primaryColor }} />,
									onCopy: () => notification.success({ message: "Copied to clipboard" }),
								}}
							>
								{streamKey}
							</Typography.Text>
						</div>
					</Col>
				)}
				{hasKey && (
					<Col flex={window.innerWidth < 768 ? 1 : undefined} style={{ margin: "8px 0" }}>
						<Button
							onClick={openGoLiveModal}
							style={{ backgroundColor: primaryColor, width: "100%" }}
							color="primary"
							data-id="btnGoLive"
						>
							<span style={{ color: "#fff", fontSize: 16 }}>
								<LiveStreamIcon style={{ marginRight: 8, transform: "scale(1.3333)" }} />
								{workout?.currently_streaming ? <span>Broadcasting</span> : "Go Live"}
							</span>
						</Button>
					</Col>
				)}
				<Col
					style={{ width: window.innerWidth < 768 ? "100%" : "unset" }}
					flex={window.innerWidth < 768 ? 1 : undefined}
				>
					<Button
						style={{ width: window.innerWidth < 768 ? "100%" : "unset" }}
						onClick={onEditClick}
						data-id="btnPencilEdit"
						disabled={workout?.type === workoutTypes.CURRENTLY_LIVE}
					>
						<Typography.Text style={{ color: primaryColor, fontSize: 16 }}>
							<PencilIcon height={16} width={16} />
							<span style={{ marginLeft: 8 }}>Edit</span>
						</Typography.Text>
					</Button>
				</Col>
			</Row>
			{workout?.currently_streaming && hasKey ? (
				<Typography.Text
					style={{ fontSize: 14, marginTop: 8, color: "#F95C25", display: "flex", alignItems: "center", gap: 8 }}
				>
					<InfoCircleOutlined />
					<span>Broadcasting will not go live until start streaming on your streaming software.</span>
				</Typography.Text>
			) : null}

			<GoLive open={isModalVisible} closeModal={() => setIsModalVisible(false)} refetchStreams={refetchStreams} />
		</Card>
	);
};

export default LiveWorkoutCard;

